// extracted by mini-css-extract-plugin
module.exports = {"edit_button":"edit_button_edit_button__226hB"};